import React, { Fragment } from "react";
import PropTypes from "prop-types";

const FormFooter = ({ onBackClick, onValidate }) => {
  return (
    <Fragment>
      <hr />

      <div className="row justify-content-between align-items-center">
        <div className="col">
          <button className="btn btn-primary rounded" onClick={onBackClick}>
            <i className="fa fa-chevron-left" aria-hidden="true"></i> Back
          </button>
        </div>

        <div className="col text-end">
          {onValidate ? (
            <button className="btn btn-danger rounded">
              <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>{" "}
              Validate
            </button>
          ) : (
            <button className="btn btn-success rounded">
              <i className="fa fa-floppy-o" aria-hidden="true"></i> Save
            </button>
          )}
        </div>
      </div>
    </Fragment>
  );
};

// Typechecking
FormFooter.propTypes = {
  onBackClick: PropTypes.func.isRequired,
  onValidate: PropTypes.object,
};

export default FormFooter;
